import { uiText } from '../utils/uiTranslation';
import React from 'react';
import './AppLoading.css';

const AppLoading = ({ inline = false, label = 'Loading...' }) => (
  <div className={inline ? 'app-loading app-loading--inline' : 'app-loading'} role="status" aria-live="polite">
    <div className="app-loading__spinner" aria-hidden="true" />
    <span className="app-loading__label">{uiText(label)}</span>
  </div>
);

export default AppLoading;
